// Mock data for Volaille Prime

export const mockProducts = [
  {
    id: 1,
    name: "Poulet Entier Frais",
    description: "Poulet frais de qualité premium, élevé localement",
    price: "Variable selon poids",
    image: "https://images.unsplash.com/photo-1587593810167-a84920ea0781",
    available: true
  },
  {
    id: 2,
    name: "Poulet Entier Congelé",
    description: "Poulet congelé dans le respect des normes d'hygiène",
    price: "Variable selon poids",
    image: "https://images.unsplash.com/photo-1604503468506-a8da13d82791",
    available: true
  },
  {
    id: 3,
    name: "Vente en Volume",
    description: "Commandes en gros pour restaurants et revendeurs",
    price: "Sur devis",
    image: "https://images.unsplash.com/photo-1694854038360-56b29a16fb0c",
    available: true
  }
];

export const mockFeatures = [
  {
    id: 1,
    title: "Production locale à Thiès",
    description: "Élevage local garantissant fraîcheur et traçabilité",
    icon: "MapPin"
  },
  {
    id: 2,
    title: "Élevage suivi par vagues",
    description: "Gestion rigoureuse pour assurer une disponibilité constante",
    icon: "Calendar"
  },
  {
    id: 3,
    title: "Poulets frais et congelés",
    description: "Options adaptées à vos besoins et préférences",
    icon: "Snowflake"
  },
  {
    id: 4,
    title: "Processus d'hygiène rigoureux",
    description: "Normes strictes pour garantir la sécurité alimentaire",
    icon: "ShieldCheck"
  },
  {
    id: 5,
    title: "Fourniture adaptée",
    description: "Service pour particuliers et professionnels",
    icon: "Users"
  },
  {
    id: 6,
    title: "Qualité constante",
    description: "Produits contrôlés pour une excellence garantie",
    icon: "Award"
  }
];

export const mockOrderSteps = [
  {
    id: 1,
    title: "Choisissez votre produit",
    description: "Sélectionnez le type de poulet souhaité",
    icon: "ShoppingCart"
  },
  {
    id: 2,
    title: "Passez commande",
    description: "Via le site ou WhatsApp",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Recevez confirmation",
    description: "Nous validons votre commande rapidement",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "Retrait ou livraison",
    description: "Selon votre choix",
    icon: "Truck"
  }
];

// Format phone number for Senegal
const formatPhoneNumber = (phone) => {
  let cleaned = phone.replace(/[\s\-\(\)]/g, '');
  if (!cleaned.startsWith('+221') && !cleaned.startsWith('221')) {
    cleaned = '+221' + cleaned;
  } else if (cleaned.startsWith('221') && !cleaned.startsWith('+')) {
    cleaned = '+' + cleaned;
  }
  return cleaned;
};

// API call to backend - FIXED VERSION
export const submitOrder = async (orderData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  
  if (!BACKEND_URL) {
    return {
      success: false,
      message: 'Configuration erreur',
      error: 'Backend URL non configurée'
    };
  }
  
  // Prepare data with proper types
  const preparedData = {
    name: orderData.name,
    phone: formatPhoneNumber(orderData.phone),
    clientType: orderData.clientType,
    city: orderData.city,
    product: orderData.product,
    quantity: parseInt(orderData.quantity, 10) || 1,
    deliveryMode: orderData.deliveryMode,
    comment: orderData.comment || '',
    acceptMarketing: orderData.acceptMarketing || false
  };
  
  try {
    const response = await fetch(`${BACKEND_URL}/api/orders/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(preparedData),
    });
    
    // Get response text first
    const responseText = await response.text();
    
    // Try to parse as JSON
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (parseError) {
      console.error('JSON parse error:', parseError, 'Response:', responseText);
      return {
        success: false,
        message: 'Erreur serveur',
        error: 'Réponse invalide du serveur'
      };
    }
    
    if (!response.ok) {
      // Handle HTTP errors
      let errorMessage = 'Erreur inconnue';
      if (responseData.detail) {
        if (Array.isArray(responseData.detail)) {
          errorMessage = responseData.detail.map(e => e.msg || e.message || JSON.stringify(e)).join(', ');
        } else {
          errorMessage = responseData.detail;
        }
      } else if (responseData.message) {
        errorMessage = responseData.message;
      }
      console.error('HTTP Error:', response.status, errorMessage);
      return {
        success: false,
        message: 'Erreur lors de l\'enregistrement',
        error: errorMessage
      };
    }
    
    // Success
    return {
      success: true,
      message: "Commande enregistrée avec succès !",
      orderId: responseData.id,
      order: responseData
    };
    
  } catch (error) {
    console.error("Order submission error:", error);
    
    // Network error
    return {
      success: false,
      message: 'Erreur de connexion',
      error: 'Impossible de contacter le serveur. Vérifiez votre connexion internet.'
    };
  }
};
